// extracted by mini-css-extract-plugin
export default {"input":"CommonSelect_input__dYdR7","label":"CommonSelect_label__qco+3"};